import { paymentMethodDisplayText } from "legacy/helpers.es6.jsx"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: jQuery ($) is loaded globally

class SelectAndAddPaymentMethodModal extends React.Component {
  constructor(props) {
    super(props)

    const firstPaymentMethod =
      this.props.paymentMethods &&
      this.props.paymentMethods[0] &&
      this.props.paymentMethods[0].stripePaymentMethodId

    this.state = {
      showModal: false,
      selectedPaymentMethodId: firstPaymentMethod,
      saving: false,
      errorMessage: null,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.save = this.save.bind(this)
    this.stopLoading = this.stopLoading.bind(this)
    this.setSelectedPaymentMethod = this.setSelectedPaymentMethod.bind(this)
  }

  openModal() {
    this.setState({ showModal: true })
  }

  closeModal() {
    this.setState({ showModal: false, errorMessage: null })
  }

  save() {
    this.setState({ saving: true })
    this.submit({ card_id: this.state.selectedPaymentMethodId })
  }

  setSelectedPaymentMethod(event) {
    this.setState({ selectedPaymentMethodId: event.target.value })
  }

  submit(params) {
    $.post(this.props.endpoint, params, () => {
      location.reload()
    }).fail((data) => {
      let error = "Failed to save payment method."
      if (data.responseText && JSON.parse(data.responseText).error) {
        error = JSON.parse(data.responseText).error
      }
      this.setState({ errorMessage: error })
      this.stopLoading()
    })
  }

  modalLinkToEditPaymentMethods() {
    return (
      <a
        href={this.props.paymentIndexPath}
        rel="noopener noreferrer"
        className="plain-link"
      >
        {"Manage Payment Methods"}
      </a>
    )
  }

  paymentMethodSelector() {
    if (this.props.paymentMethods) {
      return (
        <div className="form-group">
          <label>Select Payment Method</label>
          <select
            className="form-control"
            value={this.state.selectedPaymentMethodId}
            onChange={this.setSelectedPaymentMethod}
          >
            {this.props.paymentMethods.map((paymentMethod) => {
              return (
                <option
                  key={paymentMethod.id}
                  value={paymentMethod.stripePaymentMethodId}
                >
                  {paymentMethodDisplayText(paymentMethod)}
                </option>
              )
            })}
            {this.props.paymentMethods.length === 0 && (
              <option value="">No additional payment methods available</option>
            )}
          </select>
        </div>
      )
    }
  }

  stopLoading() {
    this.setState({ saving: false })
  }

  render() {
    return (
      <span>
        <button
          type="button"
          className={this.props.btnClassName}
          onClick={this.openModal}
          dangerouslySetInnerHTML={{
            __html: this.props.btnName || "Add New Payment Method",
          }}
        />
        {this.state.showModal && (
          <Modal
            isOpen={this.state.showModal}
            onClose={this.closeModal}
            size="mediumFixed"
          >
            <Modal.Header title="Update Payment Method" />
            <Modal.Body>
              {this.paymentMethodSelector()}
              {this.props.infoText && (
                <div className="text-muted">{this.props.infoText}</div>
              )}
              {this.state.errorMessage && (
                <div className="alert alert-danger">
                  {this.state.errorMessage}
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <div className="flex w-full justify-between">
                <div className="float-left pt-2">
                  {this.modalLinkToEditPaymentMethods()}
                </div>
                <div className="flex space-x-2">
                  <button
                    className="btn btn-secondary"
                    onClick={this.closeModal}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={this.save}
                    disabled={
                      !this.state.selectedPaymentMethodId || this.state.saving
                    }
                  >
                    {this.state.saving ? (
                      <>
                        <i className="icon icon-spinner icon-spin mr-2" />
                        Saving...
                      </>
                    ) : (
                      <>
                        <i className="icon icon-lock-fa bs-mr-3" />
                        Update
                      </>
                    )}
                  </button>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        )}
      </span>
    )
  }
}

SelectAndAddPaymentMethodModal.propTypes = {
  paymentMethods: PropTypes.array,
  endpoint: PropTypes.string.isRequired,
  paymentIndexPath: PropTypes.string.isRequired,
  btnClassName: PropTypes.string,
  btnName: PropTypes.string,
  infoText: PropTypes.string,
}

export default SelectAndAddPaymentMethodModal
